// Navigation translations
export const navTranslations = {
  en: {
    home: "Home",
    compare: "Compare",
    about: "About",
    useCases: "Use Cases",
    projects: "Qualitati",
    surveys: "Survey",
    research: "Research",
    tutorial: "Tutorial",
    themeLens: "ThemeLens",
    login: "Login",
    register: "Register",
    profile: "Profile",
    logout: "Logout",
    settings: "Settings",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    accessibility: "Accessibility Statement",
    features: "New Features",
    guide: "Interview Guide",
    notifications: "Notifications",
    assistant: "Mimi",
    interviewAssistant: "Active Listener",
    tools: "Tools",
    toolSurveyDesc: "AI-powered surveys",
    toolThemeLensDesc: "Theme analysis",
    toolAssistantDesc: "AI research assistant",
    aiInterviewer: "AI Interviewer",
    toolAiInterviewerDesc: "AI conducts interviews",
    toolInterviewAssistantDesc: "Live active listening assistant",
    proofreader: "Manuscript Proofreader",
    toolProofreaderDesc: "AI academic proofreading",
    voiceAnalytics: "Voice Analytics",
    toolVoiceAnalyticsDesc: "Acoustic feature analysis",
    qdaWorkspace: "QDA Workspace",
    toolQdaWorkspaceDesc: "Rigorous manual & AI coding workspace",
    annotator: "Annotator",
    toolAnnotatorDesc: "Multi-LLM data annotation with inter-coder reliability",
    toolAnnotatorDescLong: "Upload a spreadsheet, define your codes, run multiple LLMs in parallel, and get Krippendorff's α + Fleiss' κ automatically",
    focusGroup: "Synthetic Focus Group",
    toolFocusGroupDesc: "Multi-agent discussion simulation",
    digitalTwin: "Synthetic Human Panel",
    toolDigitalTwinDesc: "Synthetic Humans (AI personas) from real interviews",
    myInterviews: "My Interviews",
    findInterviews: "Find Interviews",
    contact: "Contact",
    blog: "Blog",
    academy: "Academy",
    dashboard: "Dashboard",
    toolDashboardWelcome: "Welcome back",
    toolDashboardSubtitle: "Your AI-powered research workspace",
    dataCollection: "Data Collection",
    analysis: "Analysis",
    researchSupport: "Research Support",
    viewTutorial: "View Tutorial",
    toolAiInterviewerDescLong: "Design & conduct AI-powered interviews",
    toolInterviewAssistantDescLong: "Real-time transcription & organization for live interviews",
    toolSurveyDescLong: "AI-driven qualitative surveys",
    toolThemeLensDescLong: "Thematic analysis across transcripts",
    toolQdaWorkspaceDescLong: "Full QDA workspace — code rigorously yourself or with AI, generate codebooks, analytics & export",
    toolVoiceAnalyticsDescLong: "Acoustic features & emotion detection",
    toolAssistantDescLong: "AI assistant that reads your project data",
    toolProofreaderDescLong: "Academic proofreading with Track Changes",
    simulation: "Simulation & Synthetic Data",
    toolFocusGroupDescLong: "Multi-agent AI discussion on your research topic before fieldwork",
    toolDigitalTwinDescLong: "Extract Synthetic Humans (AI personas) from real interviews and deploy for future studies",
    solutions: "Solutions",
    forMarketing: "For Marketing",
    forMarketingDesc: "VoC, message testing, JTBD",
    forUx: "For UX & Product",
    forUxDesc: "User interviews, usability",
    forHr: "For HR & People",
    forHrDesc: "Exit, engagement, DEI",
    forTeams: "For Teams (B2B)",
    forTeamsDesc: "Multi-seat workspaces",
    forAcademic: "For Academic Research",
    forAcademicDesc: "PhD, faculty, labs",
    developers: "Developers"
  },
  zh: {
    home: "首页",
    compare: "对比",
    about: "关于我们",
    useCases: "使用案例",
    projects: "Qualitati",
    surveys: "问卷调查",
    research: "研究",
    tutorial: "教程",
    themeLens: "ThemeLens",
    login: "登录",
    register: "注册",
    profile: "个人资料",
    logout: "退出登录",
    settings: "设置",
    privacy: "隐私政策",
    terms: "服务条款",
    accessibility: "无障碍声明",
    features: "新功能",
    guide: "使用指南",
    notifications: "通知",
    assistant: "Mimi",
    interviewAssistant: "主动倾听助手",
    tools: "工具箱",
    toolSurveyDesc: "AI驱动的问卷调查",
    toolThemeLensDesc: "主题分析",
    toolAssistantDesc: "AI研究助手",
    aiInterviewer: "AI访谈员",
    toolAiInterviewerDesc: "AI主导访谈",
    toolInterviewAssistantDesc: "实时主动倾听助手",
    proofreader: "论文校对",
    toolProofreaderDesc: "AI学术论文校对",
    voiceAnalytics: "语音分析",
    toolVoiceAnalyticsDesc: "声学特征分析",
    qdaWorkspace: "QDA 工作区",
    toolQdaWorkspaceDesc: "严谨的手动与AI编码工作区",
    annotator: "标注器",
    toolAnnotatorDesc: "多模型数据标注及编码者一致性",
    toolAnnotatorDescLong: "上传表格，定义编码方案，并行调用多个LLM，自动得到 Krippendorff α 与 Fleiss κ",
    focusGroup: "合成焦点小组",
    toolFocusGroupDesc: "多代理讨论模拟",
    digitalTwin: "合成人面板",
    toolDigitalTwinDesc: "从真实访谈创建合成人（AI人格）",
    myInterviews: "��的访谈",
    findInterviews: "寻找访谈",
    contact: "联系我们",
    blog: "博客",
    academy: "学院",
    dashboard: "工作台",
    toolDashboardWelcome: "欢迎回来",
    toolDashboardSubtitle: "您的AI驱动研究工作空间",
    dataCollection: "数据收集",
    analysis: "分析",
    researchSupport: "研究支持",
    viewTutorial: "查看教程",
    toolAiInterviewerDescLong: "设计并进行AI驱动的访谈",
    toolInterviewAssistantDescLong: "实时转录与整理您的访谈",
    toolSurveyDescLong: "AI驱动的质性问卷调查",
    toolThemeLensDescLong: "跨文本主题分析",
    toolQdaWorkspaceDescLong: "完整的QDA工作区 — 自行严谨编码或借助AI编码，生成编码手册、分析与导出",
    toolVoiceAnalyticsDescLong: "声学特征与情感检测",
    toolAssistantDescLong: "AI助手可读取您的项目数据",
    toolProofreaderDescLong: "带修订追踪的学术校对",
    simulation: "模拟与合成数据",
    toolFocusGroupDescLong: "在实地调研前进行多代理AI主题讨论",
    toolDigitalTwinDescLong: "从真实访谈中提取合成人（AI人格）并用于未来研究",
    solutions: "解决方案",
    forMarketing: "面向市场营销",
    forMarketingDesc: "客户之声、信息测试、JTBD",
    forUx: "面向 UX 与产品",
    forUxDesc: "用户访谈、易用性",
    forHr: "面向人力资源",
    forHrDesc: "离职、敬业度、DEI",
    forTeams: "面向团队 (B2B)",
    forTeamsDesc: "多席位工作区",
    forAcademic: "面向学术研究",
    forAcademicDesc: "博士生、教师、实验室",
    developers: "开发者"
  },
  fr: {
    home: "Accueil",
    compare: "Comparatif",
    about: "À Propos",
    useCases: "Cas d'Usage",
    projects: "Qualitati",
    surveys: "Enquête",
    research: "Recherche",
    tutorial: "Tutoriel",
    themeLens: "ThemeLens",
    login: "Connexion",
    register: "Inscription",
    profile: "Profil",
    logout: "Déconnexion",
    settings: "Paramètres",
    privacy: "Politique de Confidentialité",
    terms: "Conditions d'Utilisation",
    accessibility: "Déclaration d'Accessibilité",
    features: "Nouvelles fonctionnalités",
    guide: "Guide d'entretien",
    notifications: "Notifications",
    assistant: "Mimi",
    interviewAssistant: "Écoute Active",
    tools: "Outils",
    toolSurveyDesc: "Enquêtes par IA",
    toolThemeLensDesc: "Analyse thématique",
    toolAssistantDesc: "IA qualitative",
    aiInterviewer: "Intervieweur IA",
    toolAiInterviewerDesc: "L'IA mène les entretiens",
    toolInterviewAssistantDesc: "Assistant d'Écoute Active en direct",
    proofreader: "Correcteur de manuscrit",
    toolProofreaderDesc: "Relecture académique par IA",
    voiceAnalytics: "Analyse Vocale",
    toolVoiceAnalyticsDesc: "Analyse des caractéristiques acoustiques",
    qdaWorkspace: "Espace QDA",
    toolQdaWorkspaceDesc: "Espace de codage manuel et IA rigoureux",
    annotator: "Annotator",
    toolAnnotatorDesc: "Annotation multi-LLM avec fiabilité inter-codeurs",
    toolAnnotatorDescLong: "Importez un tableur, définissez vos codes, exécutez plusieurs LLM en parallèle, et obtenez Krippendorff α + Fleiss κ automatiquement",
    focusGroup: "Groupe de discussion synthétique",
    toolFocusGroupDesc: "Simulation de discussion multi-agents",
    digitalTwin: "Panel d'humains synthétiques",
    toolDigitalTwinDesc: "Humains synthétiques issus d'entretiens réels",
    myInterviews: "Mes entretiens",
    findInterviews: "Trouver des entretiens",
    contact: "Contact",
    blog: "Blog",
    academy: "Académie",
    dashboard: "Tableau de bord",
    toolDashboardWelcome: "Bon retour",
    toolDashboardSubtitle: "Votre espace de recherche propulsé par l'IA",
    dataCollection: "Collecte de données",
    analysis: "Analyse",
    researchSupport: "Support de recherche",
    viewTutorial: "Voir le tutoriel",
    toolAiInterviewerDescLong: "Concevez et menez des entretiens par IA",
    toolInterviewAssistantDescLong: "Transcription et organisation en temps réel pour les entretiens",
    toolSurveyDescLong: "Enquêtes qualitatives par IA",
    toolThemeLensDescLong: "Analyse thématique des transcriptions",
    toolQdaWorkspaceDescLong: "Espace QDA complet — codez rigoureusement vous-même ou avec l'IA, générez des livres de codes, analyses et exports",
    toolVoiceAnalyticsDescLong: "Caractéristiques acoustiques et détection d'émotions",
    toolAssistantDescLong: "Assistante IA qui lit vos données de projet",
    toolProofreaderDescLong: "Relecture académique avec suivi des modifications",
    simulation: "Simulation et données synthétiques",
    toolFocusGroupDescLong: "Discussion IA multi-agents sur votre sujet de recherche avant le terrain",
    toolDigitalTwinDescLong: "Extraire des humains synthétiques d'entretiens réels pour de futures études",
    solutions: "Solutions",
    forMarketing: "Pour le marketing",
    forMarketingDesc: "VoC, test de messages, JTBD",
    forUx: "Pour UX et produit",
    forUxDesc: "Entretiens utilisateurs, usabilité",
    forHr: "Pour les RH",
    forHrDesc: "Départ, engagement, DEI",
    forTeams: "Pour les équipes (B2B)",
    forTeamsDesc: "Espaces multi-sièges",
    forAcademic: "Pour la recherche académique",
    forAcademicDesc: "Doctorants, enseignants, labos",
    developers: "Développeurs"
  },
  nb: {
    home: "Hjem",
    compare: "Sammenlign",
    about: "Om Oss",
    useCases: "Bruksområder",
    projects: "Qualitati",
    surveys: "Spørreundersøkelse",
    research: "Forskning",
    tutorial: "Veiledning",
    themeLens: "ThemeLens",
    login: "Logg Inn",
    register: "Registrer",
    profile: "Profil",
    logout: "Logg Ut",
    settings: "Innstillinger",
    privacy: "Personvernregler",
    terms: "Vilkår for bruk",
    accessibility: "Tilgjengelighetserklæring",
    features: "Nye funksjoner",
    guide: "Intervjuguide",
    notifications: "Varslinger",
    assistant: "Mimi",
    interviewAssistant: "Aktiv Lytter",
    tools: "Verktøy",
    toolSurveyDesc: "AI-drevne spørreundersøkelser",
    toolThemeLensDesc: "Temaanalyse",
    toolAssistantDesc: "AI kvalitativ assistent",
    aiInterviewer: "AI-intervjuer",
    toolAiInterviewerDesc: "AI gjennomfører intervjuer",
    toolInterviewAssistantDesc: "Live aktiv lytte-assistent",
    proofreader: "Manuskriptkorrektur",
    toolProofreaderDesc: "AI akademisk korrekturlesing",
    voiceAnalytics: "Stemmeanalyse",
    toolVoiceAnalyticsDesc: "Analyse av akustiske egenskaper",
    qdaWorkspace: "QDA-arbeidsrom",
    toolQdaWorkspaceDesc: "Grundig manuell og AI-kodingsarbeidsrom",
    annotator: "Annotator",
    toolAnnotatorDesc: "Fler-LLM datakoding med inter-koder-reliabilitet",
    toolAnnotatorDescLong: "Last opp et regneark, definer kodene dine, kjør flere LLM-er parallelt og få Krippendorff α + Fleiss κ automatisk",
    focusGroup: "Syntetisk fokusgruppe",
    toolFocusGroupDesc: "Multi-agent diskusjonssimulering",
    digitalTwin: "Syntetisk menneske-panel",
    toolDigitalTwinDesc: "Syntetiske mennesker fra ekte intervjuer",
    myInterviews: "Mine intervjuer",
    findInterviews: "Finn intervjuer",
    contact: "Kontakt",
    blog: "Blogg",
    academy: "Akademi",
    dashboard: "Dashbord",
    toolDashboardWelcome: "Velkommen tilbake",
    toolDashboardSubtitle: "Ditt AI-drevne forskningsarbeidsområde",
    dataCollection: "Datainnsamling",
    analysis: "Analyse",
    researchSupport: "Forskningsstøtte",
    viewTutorial: "Se veiledning",
    toolAiInterviewerDescLong: "Design og gjennomfør AI-drevne intervjuer",
    toolInterviewAssistantDescLong: "Sanntidstranskripsjon og organisering for live intervjuer",
    toolSurveyDescLong: "AI-drevne kvalitative spørreundersøkelser",
    toolThemeLensDescLong: "Tematisk analyse på tvers av transkripsjoner",
    toolQdaWorkspaceDescLong: "Fullstendig QDA-arbeidsrom — kod grundig selv eller med AI, generer kodebøker, analyser og eksporter",
    toolVoiceAnalyticsDescLong: "Akustiske egenskaper og følelsesdeteksjon",
    toolAssistantDescLong: "AI-assistent som leser prosjektdataene dine",
    toolProofreaderDescLong: "Akademisk korrekturlesing med endringssporing",
    simulation: "Simulering og syntetiske data",
    toolFocusGroupDescLong: "Multi-agent AI-diskusjon om forskningstemaet ditt før feltarbeid",
    toolDigitalTwinDescLong: "Trekk ut syntetiske mennesker fra ekte intervjuer for fremtidige studier",
    solutions: "Løsninger",
    forMarketing: "For markedsføring",
    forMarketingDesc: "VoC, meldingstesting, JTBD",
    forUx: "For UX og produkt",
    forUxDesc: "Brukerintervjuer, brukbarhet",
    forHr: "For HR og folk",
    forHrDesc: "Sluttsamtaler, engasjement, DEI",
    forTeams: "For team (B2B)",
    forTeamsDesc: "Flerseters arbeidsområder",
    forAcademic: "For akademisk forskning",
    forAcademicDesc: "PhD, fakultet, laber",
    developers: "Utviklere"
  },
  nl: {
    home: "Home",
    compare: "Vergelijken",
    about: "Over Ons",
    useCases: "Gebruikssituaties",
    projects: "Qualitati",
    surveys: "Enquête",
    research: "Onderzoek",
    tutorial: "Handleiding",
    themeLens: "ThemeLens",
    login: "Inloggen",
    register: "Registreren",
    profile: "Profiel",
    logout: "Uitloggen",
    settings: "Instellingen",
    privacy: "Privacybeleid",
    terms: "Servicevoorwaarden",
    accessibility: "Toegankelijkheidsverklaring",
    features: "Nieuwe functies",
    guide: "Interviewgids",
    notifications: "Meldingen",
    assistant: "Mimi",
    interviewAssistant: "Actieve Luisteraar",
    tools: "Gereedschappen",
    toolSurveyDesc: "AI-gestuurde enquêtes",
    toolThemeLensDesc: "Thema-analyse",
    toolAssistantDesc: "AI kwalitatieve assistent",
    aiInterviewer: "AI Interviewer",
    toolAiInterviewerDesc: "AI voert interviews",
    toolInterviewAssistantDesc: "Live actieve luister-assistent",
    proofreader: "Manuscript Proofreader",
    toolProofreaderDesc: "AI academische proeflees",
    voiceAnalytics: "Stemanalyse",
    toolVoiceAnalyticsDesc: "Analyse van akoestische kenmerken",
    qdaWorkspace: "QDA-werkruimte",
    toolQdaWorkspaceDesc: "Rigoureuze handmatige en AI-coderingsruimte",
    annotator: "Annotator",
    toolAnnotatorDesc: "Multi-LLM data-annotatie met inter-coder-betrouwbaarheid",
    toolAnnotatorDescLong: "Upload een spreadsheet, definieer codes, draai meerdere LLM's parallel en krijg Krippendorff α + Fleiss κ automatisch",
    focusGroup: "Synthetische focusgroep",
    toolFocusGroupDesc: "Multi-agent discussiesimulatie",
    digitalTwin: "Synthetische mens panel",
    toolDigitalTwinDesc: "Synthetische mensen van echte interviews",
    myInterviews: "Mijn interviews",
    findInterviews: "Interviews zoeken",
    contact: "Contact",
    blog: "Blog",
    academy: "Academie",
    dashboard: "Dashboard",
    toolDashboardWelcome: "Welkom terug",
    toolDashboardSubtitle: "Uw AI-aangedreven onderzoekswerkruimte",
    dataCollection: "Gegevensverzameling",
    analysis: "Analyse",
    researchSupport: "Onderzoeksondersteuning",
    viewTutorial: "Handleiding bekijken",
    toolAiInterviewerDescLong: "Ontwerp en voer AI-gestuurde interviews uit",
    toolInterviewAssistantDescLong: "Realtime transcriptie en organisatie voor live interviews",
    toolSurveyDescLong: "AI-gestuurde kwalitatieve enquêtes",
    toolThemeLensDescLong: "Thematische analyse van transcripties",
    toolQdaWorkspaceDescLong: "Volledige QDA-werkruimte — codeer zelf grondig of met AI, genereer codeboeken, analyses en exports",
    toolVoiceAnalyticsDescLong: "Akoestische kenmerken en emotiedetectie",
    toolAssistantDescLong: "AI-assistent die uw projectdata leest",
    toolProofreaderDescLong: "Academisch proeflezen met wijzigingen bijhouden",
    simulation: "Simulatie en synthetische data",
    toolFocusGroupDescLong: "Multi-agent AI-discussie over uw onderzoeksonderwerp vóór veldwerk",
    toolDigitalTwinDescLong: "Synthetische mensen uit echte interviews extraheren voor toekomstig onderzoek",
    solutions: "Oplossingen",
    forMarketing: "Voor marketing",
    forMarketingDesc: "VoC, message testing, JTBD",
    forUx: "Voor UX en product",
    forUxDesc: "Gebruikersinterviews, usability",
    forHr: "Voor HR en people",
    forHrDesc: "Exit, betrokkenheid, DEI",
    forTeams: "Voor teams (B2B)",
    forTeamsDesc: "Multi-seat workspaces",
    forAcademic: "Voor academisch onderzoek",
    forAcademicDesc: "PhD, faculteit, labs",
    developers: "Ontwikkelaars"
  },
  de: {
    home: "Startseite",
    compare: "Vergleich",
    about: "Über Uns",
    useCases: "Anwendungsfälle",
    projects: "Qualitati",
    surveys: "Umfrage",
    research: "Forschung",
    tutorial: "Anleitung",
    themeLens: "ThemeLens",
    login: "Anmelden",
    register: "Registrieren",
    profile: "Profil",
    logout: "Abmelden",
    settings: "Einstellungen",
    privacy: "Datenschutzrichtlinie",
    terms: "Nutzungsbedingungen",
    accessibility: "Barrierefreiheitserklärung",
    features: "Neue Funktionen",
    guide: "Interview-Leitfaden",
    notifications: "Benachrichtigungen",
    assistant: "Mimi",
    interviewAssistant: "Aktiver Zuhörer",
    tools: "Werkzeuge",
    toolSurveyDesc: "KI-gestützte Umfragen",
    toolThemeLensDesc: "Themenanalyse",
    toolAssistantDesc: "KI-Qualitätsassistent",
    aiInterviewer: "KI-Interviewer",
    toolAiInterviewerDesc: "KI führt Interviews",
    toolInterviewAssistantDesc: "Live aktiver Zuhör-Assistent",
    proofreader: "Manuskript-Korrektor",
    toolProofreaderDesc: "KI-akademisches Korrekturlesen",
    voiceAnalytics: "Sprachanalyse",
    toolVoiceAnalyticsDesc: "Analyse akustischer Merkmale",
    qdaWorkspace: "QDA-Arbeitsbereich",
    toolQdaWorkspaceDesc: "Gründlicher manueller und KI-Kodierungsarbeitsbereich",
    annotator: "Annotator",
    toolAnnotatorDesc: "Multi-LLM-Datenannotation mit Inter-Coder-Reliabilität",
    toolAnnotatorDescLong: "Tabelle hochladen, Codes definieren, mehrere LLMs parallel laufen lassen — und Krippendorff α + Fleiss κ automatisch erhalten",
    focusGroup: "Synthetische Fokusgruppe",
    toolFocusGroupDesc: "Multi-Agenten-Diskussionssimulation",
    digitalTwin: "Synthetic-Human-Panel",
    toolDigitalTwinDesc: "Synthetic Humans aus echten Interviews",
    myInterviews: "Meine Interviews",
    findInterviews: "Interviews finden",
    contact: "Kontakt",
    blog: "Blog",
    academy: "Akademie",
    dashboard: "Dashboard",
    toolDashboardWelcome: "Willkommen zurück",
    toolDashboardSubtitle: "Ihr KI-gestützter Forschungsarbeitsbereich",
    dataCollection: "Datenerfassung",
    analysis: "Analyse",
    researchSupport: "Forschungsunterstützung",
    viewTutorial: "Anleitung ansehen",
    toolAiInterviewerDescLong: "KI-gestützte Interviews entwerfen und durchführen",
    toolInterviewAssistantDescLong: "Echtzeit-Transkription und Organisation für Live-Interviews",
    toolSurveyDescLong: "KI-gestützte qualitative Umfragen",
    toolThemeLensDescLong: "Themenanalyse über Transkripte hinweg",
    toolQdaWorkspaceDescLong: "Vollständiger QDA-Arbeitsbereich — selbst gründlich kodieren oder mit KI, Codebücher, Analysen und Export erstellen",
    toolVoiceAnalyticsDescLong: "Akustische Merkmale und Emotionserkennung",
    toolAssistantDescLong: "KI-Assistent, der Ihre Projektdaten liest",
    toolProofreaderDescLong: "Akademisches Korrekturlesen mit Änderungsverfolgung",
    simulation: "Simulation und synthetische Daten",
    toolFocusGroupDescLong: "Multi-Agenten-KI-Diskussion zu Ihrem Forschungsthema vor der Feldarbeit",
    toolDigitalTwinDescLong: "Synthetic Humans aus echten Interviews für zukünftige Studien extrahieren",
    solutions: "Lösungen",
    forMarketing: "Für Marketing",
    forMarketingDesc: "VoC, Message-Testing, JTBD",
    forUx: "Für UX & Produkt",
    forUxDesc: "Nutzerinterviews, Usability",
    forHr: "Für HR & People",
    forHrDesc: "Exit, Engagement, DEI",
    forTeams: "Für Teams (B2B)",
    forTeamsDesc: "Multi-Seat-Workspaces",
    forAcademic: "Für akademische Forschung",
    forAcademicDesc: "PhD, Fakultät, Labore",
    developers: "Entwickler"
  },
  es: {
    home: "Inicio",
    compare: "Comparar",
    about: "Acerca de",
    useCases: "Casos de Uso",
    projects: "Qualitati",
    surveys: "Encuesta",
    research: "Investigación",
    tutorial: "Tutorial",
    themeLens: "ThemeLens",
    login: "Iniciar Sesión",
    register: "Registrarse",
    profile: "Perfil",
    logout: "Cerrar Sesión",
    settings: "Configuración",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio",
    accessibility: "Declaración de Accesibilidad",
    features: "Nuevas funciones",
    guide: "Guía de entrevista",
    notifications: "Notificaciones",
    assistant: "Mimi",
    interviewAssistant: "Escucha Activa",
    tools: "Herramientas",
    toolSurveyDesc: "Encuestas con IA",
    toolThemeLensDesc: "Análisis temático",
    toolAssistantDesc: "Asistente cualitativo IA",
    aiInterviewer: "Entrevistador IA",
    toolAiInterviewerDesc: "La IA realiza entrevistas",
    toolInterviewAssistantDesc: "Asistente de Escucha Activa en vivo",
    proofreader: "Corrector de manuscritos",
    toolProofreaderDesc: "Corrección académica con IA",
    voiceAnalytics: "Análisis de Voz",
    toolVoiceAnalyticsDesc: "Análisis de características acústicas",
    qdaWorkspace: "Espacio de trabajo QDA",
    toolQdaWorkspaceDesc: "Espacio de codificación manual y con IA riguroso",
    annotator: "Annotator",
    toolAnnotatorDesc: "Anotación multi-LLM con fiabilidad inter-codificadores",
    toolAnnotatorDescLong: "Sube una hoja de cálculo, define códigos, ejecuta varios LLM en paralelo y obtén Krippendorff α + Fleiss κ automáticamente",
    focusGroup: "Grupo focal sintético",
    toolFocusGroupDesc: "Simulación de discusión multi-agente",
    digitalTwin: "Panel de humanos sintéticos",
    toolDigitalTwinDesc: "Humanos sintéticos de entrevistas reales",
    myInterviews: "Mis entrevistas",
    findInterviews: "Buscar entrevistas",
    contact: "Contacto",
    blog: "Blog",
    academy: "Academia",
    dashboard: "Panel",
    toolDashboardWelcome: "Bienvenido de nuevo",
    toolDashboardSubtitle: "Tu espacio de investigación impulsado por IA",
    dataCollection: "Recopilación de datos",
    analysis: "Análisis",
    researchSupport: "Apoyo a la investigación",
    viewTutorial: "Ver tutorial",
    toolAiInterviewerDescLong: "Diseña y realiza entrevistas con IA",
    toolInterviewAssistantDescLong: "Transcripción y organización en tiempo real para entrevistas",
    toolSurveyDescLong: "Encuestas cualitativas con IA",
    toolThemeLensDescLong: "Análisis temático de transcripciones",
    toolQdaWorkspaceDescLong: "Espacio QDA completo — codifique rigurosamente usted mismo o con IA, genere libros de códigos, análisis y exportaciones",
    toolVoiceAnalyticsDescLong: "Características acústicas y detección de emociones",
    toolAssistantDescLong: "Asistente IA que lee los datos de tu proyecto",
    toolProofreaderDescLong: "Corrección académica con control de cambios",
    simulation: "Simulación y datos sintéticos",
    toolFocusGroupDescLong: "Discusión IA multi-agente sobre su tema de investigación antes del trabajo de campo",
    toolDigitalTwinDescLong: "Extraer humanos sintéticos de entrevistas reales para estudios futuros",
    solutions: "Soluciones",
    forMarketing: "Para marketing",
    forMarketingDesc: "VoC, pruebas de mensajes, JTBD",
    forUx: "Para UX y producto",
    forUxDesc: "Entrevistas de usuario, usabilidad",
    forHr: "Para RR. HH.",
    forHrDesc: "Salida, engagement, DEI",
    forTeams: "Para equipos (B2B)",
    forTeamsDesc: "Espacios multiusuario",
    forAcademic: "Para investigación académica",
    forAcademicDesc: "Doctorado, profesorado, labs",
    developers: "Desarrolladores"
  },
  pt: {
    home: "Início",
    compare: "Comparar",
    about: "Sobre",
    useCases: "Casos de Uso",
    projects: "Qualitati",
    surveys: "Pesquisa",
    research: "Pesquisa",
    tutorial: "Tutorial",
    themeLens: "ThemeLens",
    login: "Entrar",
    register: "Registrar",
    profile: "Perfil",
    logout: "Sair",
    settings: "Configurações",
    privacy: "Política de Privacidade",
    terms: "Termos de Serviço",
    accessibility: "Declaração de Acessibilidade",
    features: "Novos recursos",
    guide: "Guia de entrevista",
    notifications: "Notificações",
    assistant: "Mimi",
    interviewAssistant: "Escuta Ativa",
    tools: "Ferramentas",
    toolSurveyDesc: "Pesquisas com IA",
    toolThemeLensDesc: "Análise temática",
    toolAssistantDesc: "Assistente de pesquisa IA",
    aiInterviewer: "Entrevistador IA",
    toolAiInterviewerDesc: "IA conduz entrevistas",
    toolInterviewAssistantDesc: "Assistente de Escuta Ativa ao vivo",
    proofreader: "Revisor de Manuscrito",
    toolProofreaderDesc: "Revisão acadêmica com IA",
    voiceAnalytics: "Análise de Voz",
    toolVoiceAnalyticsDesc: "Análise de características acústicas",
    qdaWorkspace: "Espaço de trabalho QDA",
    toolQdaWorkspaceDesc: "Espaço de codificação manual e com IA rigoroso",
    annotator: "Annotator",
    toolAnnotatorDesc: "Anotação multi-LLM com confiabilidade inter-codificadores",
    toolAnnotatorDescLong: "Envie uma planilha, defina os códigos, rode múltiplos LLMs em paralelo e obtenha Krippendorff α + Fleiss κ automaticamente",
    focusGroup: "Grupo focal sintético",
    toolFocusGroupDesc: "Simulação de discussão multi-agente",
    digitalTwin: "Painel de humanos sintéticos",
    toolDigitalTwinDesc: "Humanos sintéticos de entrevistas reais",
    myInterviews: "Minhas entrevistas",
    findInterviews: "Encontrar entrevistas",
    contact: "Contato",
    blog: "Blog",
    academy: "Academia",
    dashboard: "Painel",
    toolDashboardWelcome: "Bem-vindo de volta",
    toolDashboardSubtitle: "Seu espaço de pesquisa com IA",
    dataCollection: "Coleta de dados",
    analysis: "Análise",
    researchSupport: "Suporte à pesquisa",
    viewTutorial: "Ver tutorial",
    toolAiInterviewerDescLong: "Projete e conduza entrevistas com IA",
    toolInterviewAssistantDescLong: "Transcrição e organização em tempo real para entrevistas",
    toolSurveyDescLong: "Pesquisas qualitativas com IA",
    toolThemeLensDescLong: "Análise temática de transcrições",
    toolQdaWorkspaceDescLong: "Espaço QDA completo — codifique rigorosamente você mesmo ou com IA, gere livros de códigos, análises e exportações",
    toolVoiceAnalyticsDescLong: "Características acústicas e detecção de emoções",
    toolAssistantDescLong: "Assistente IA que lê os dados do seu projeto",
    toolProofreaderDescLong: "Revisão acadêmica com controle de alterações",
    simulation: "Simulação e dados sintéticos",
    toolFocusGroupDescLong: "Discussão IA multi-agente sobre seu tema de pesquisa antes do trabalho de campo",
    toolDigitalTwinDescLong: "Extrair humanos sintéticos de entrevistas reais para estudos futuros",
    solutions: "Soluções",
    forMarketing: "Para marketing",
    forMarketingDesc: "VoC, teste de mensagens, JTBD",
    forUx: "Para UX e produto",
    forUxDesc: "Entrevistas de usuário, usabilidade",
    forHr: "Para RH",
    forHrDesc: "Saída, engajamento, DEI",
    forTeams: "Para equipes (B2B)",
    forTeamsDesc: "Espaços multiusuário",
    forAcademic: "Para pesquisa acadêmica",
    forAcademicDesc: "Doutorado, docentes, labs",
    developers: "Desenvolvedores"
  },
  ja: {
    home: "ホーム",
    compare: "比較",
    about: "概要",
    useCases: "ユースケース",
    projects: "Qualitati",
    surveys: "調査",
    research: "研究",
    tutorial: "チュートリアル",
    themeLens: "ThemeLens",
    login: "ログイン",
    register: "登録",
    profile: "プロフィール",
    logout: "ログアウト",
    settings: "設定",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    accessibility: "アクセシビリティ声明",
    features: "新機能",
    guide: "インタビューガイド",
    notifications: "通知",
    assistant: "Mimi",
    interviewAssistant: "アクティブリスナー",
    tools: "ツール",
    toolSurveyDesc: "AIアンケート",
    toolThemeLensDesc: "テーマ分析",
    toolAssistantDesc: "AI研究アシスタント",
    aiInterviewer: "AIインタビュアー",
    toolAiInterviewerDesc: "AIがインタビューを実施",
    toolInterviewAssistantDesc: "ライブアクティブリスニングアシスタント",
    proofreader: "原稿校正",
    toolProofreaderDesc: "AI学術校正",
    voiceAnalytics: "音声分析",
    toolVoiceAnalyticsDesc: "音響特徴分析",
    qdaWorkspace: "QDAワークスペース",
    toolQdaWorkspaceDesc: "厳密な手動・AIコーディングワークスペース",
    annotator: "Annotator",
    toolAnnotatorDesc: "複数LLMによるアノテーションとコーダー間信頼性",
    toolAnnotatorDescLong: "表をアップロード、コードを定義、複数のLLMを並列実行し、Krippendorff α と Fleiss κ を自動取得",
    focusGroup: "合成フォーカスグループ",
    toolFocusGroupDesc: "マルチエージェントディスカッションシミュレーション",
    digitalTwin: "合成人間パネル",
    toolDigitalTwinDesc: "実際のインタビューからの合成人間",
    myInterviews: "マイインタビュー",
    findInterviews: "インタビューを探す",
    contact: "お問い合わせ",
    blog: "ブログ",
    academy: "アカデミー",
    dashboard: "ダッシュボード",
    toolDashboardWelcome: "おかえりなさい",
    toolDashboardSubtitle: "AI搭載の研究ワークスペース",
    dataCollection: "データ収集",
    analysis: "分析",
    researchSupport: "研究サポート",
    viewTutorial: "チュートリアルを見る",
    toolAiInterviewerDescLong: "AIインタビューの設計と実施",
    toolInterviewAssistantDescLong: "ライブインタビューのリアルタイム文字起こしと整理",
    toolSurveyDescLong: "AI駆動の質的調査",
    toolThemeLensDescLong: "トランスクリプト全体のテーマ分析",
    toolQdaWorkspaceDescLong: "完全なQDAワークスペース — 自分で厳密にコーディングまたはAIで、コードブック・分析・エクスポートを生成",
    toolVoiceAnalyticsDescLong: "音響特徴と感情検出",
    toolAssistantDescLong: "プロジェクトデータを読み取るAIアシスタント",
    toolProofreaderDescLong: "変更履歴付き学術校正",
    simulation: "シミュレーションと合成データ",
    toolFocusGroupDescLong: "フィールドワーク前に研究テーマについてマルチエージェントAIディスカッション",
    toolDigitalTwinDescLong: "実際のインタビューから合成人間を抽出し将来の研究に活用",
    solutions: "ソリューション",
    forMarketing: "マーケティング向け",
    forMarketingDesc: "VoC、メッセージテスト、JTBD",
    forUx: "UX・プロダクト向け",
    forUxDesc: "ユーザーインタビュー、ユーザビリティ",
    forHr: "人事向け",
    forHrDesc: "退職、エンゲージメント、DEI",
    forTeams: "チーム向け (B2B)",
    forTeamsDesc: "マルチシートワークスペース",
    forAcademic: "学術研究向け",
    forAcademicDesc: "博士課程、教員、研究室",
    developers: "開発者"
  },
  ar: {
    home: "الرئيسية",
    compare: "مقارنة",
    about: "حول",
    useCases: "حالات الاستخدام",
    projects: "Qualitati",
    surveys: "استطلاع",
    research: "البحث",
    tutorial: "البرنامج التعليمي",
    themeLens: "ThemeLens",
    login: "تسجيل الدخول",
    register: "التسجيل",
    profile: "الملف الشخصي",
    logout: "تسجيل الخروج",
    settings: "الإعدادات",
    privacy: "سياسة الخصوصية",
    terms: "شروط الخدمة",
    accessibility: "بيان إمكانية الوصول",
    features: "الميزات الجديدة",
    guide: "دليل المقابلة",
    notifications: "الإشعارات",
    assistant: "Mimi",
    interviewAssistant: "المستمع النشط",
    tools: "الأدوات",
    toolSurveyDesc: "استطلاعات بالذكاء الاصطناعي",
    toolThemeLensDesc: "تحليل موضوعي",
    toolAssistantDesc: "مساعد بحث ذكاء اصطناعي",
    aiInterviewer: "مقابل الذكاء الاصطناعي",
    toolAiInterviewerDesc: "الذكاء الاصطناعي يجري المقابلات",
    toolInterviewAssistantDesc: "مساعد الاستماع النشط المباشر",
    proofreader: "مدقق المخطوطات",
    toolProofreaderDesc: "تدقيق أكاديمي بالذكاء الاصطناعي",
    voiceAnalytics: "تحليل الصوت",
    toolVoiceAnalyticsDesc: "تحليل الميزات الصوتية",
    qdaWorkspace: "مساحة عمل QDA",
    toolQdaWorkspaceDesc: "مساحة عمل ترميز يدوي وذكاء اصطناعي دقيقة",
    annotator: "Annotator",
    toolAnnotatorDesc: "ترميز بيانات متعدد النماذج مع موثوقية المُرَمِّزين",
    toolAnnotatorDescLong: "ارفع جدول بيانات، عرّف الأكواد، شغّل عدة LLM بالتوازي، واحصل تلقائياً على Krippendorff α و Fleiss κ",
    focusGroup: "مجموعة تركيز اصطناعية",
    toolFocusGroupDesc: "محاكاة نقاش متعدد الوكلاء",
    digitalTwin: "لوحة الإنسان الاصطناعي",
    toolDigitalTwinDesc: "بشر اصطناعيون من مقابلات حقيقية",
    myInterviews: "مقابلاتي",
    findInterviews: "البحث عن مقابلات",
    contact: "تواصل معنا",
    blog: "المدونة",
    academy: "الأكاديمية",
    dashboard: "لوحة التحكم",
    toolDashboardWelcome: "مرحبًا بعودتك",
    toolDashboardSubtitle: "مساحة البحث المدعومة بالذكاء الاصطناعي",
    dataCollection: "جمع البيانات",
    analysis: "التحليل",
    researchSupport: "دعم البحث",
    viewTutorial: "عرض البرنامج التعليمي",
    toolAiInterviewerDescLong: "تصميم وإجراء مقابلات بالذكاء الاصطناعي",
    toolInterviewAssistantDescLong: "نسخ وتنظيم مباشر للمقابلات الحية",
    toolSurveyDescLong: "استطلاعات نوعية بالذكاء الاصطناعي",
    toolThemeLensDescLong: "تحليل موضوعي عبر النصوص المفرغة",
    toolQdaWorkspaceDescLong: "مساحة عمل QDA كاملة — رمّز بدقة بنفسك أو بمساعدة الذكاء الاصطناعي، وأنشئ كتب الرموز والتحليلات والتصدير",
    toolVoiceAnalyticsDescLong: "ميزات صوتية وكشف المشاعر",
    toolAssistantDescLong: "مساعد ذكاء اصطناعي يقرأ بيانات مشروعك",
    toolProofreaderDescLong: "تدقيق أكاديمي مع تتبع التغييرات",
    simulation: "المحاكاة والبيانات الاصطناعية",
    toolFocusGroupDescLong: "نقاش ذكاء اصطناعي متعدد الوكلاء حول موضوع بحثك قبل العمل الميداني",
    toolDigitalTwinDescLong: "استخراج بشر اصطناعيين من مقابلات حقيقية لدراسات مستقبلية",
    solutions: "الحلول",
    forMarketing: "للتسويق",
    forMarketingDesc: "صوت العميل، اختبار الرسائل، JTBD",
    forUx: "لـ UX والمنتج",
    forUxDesc: "مقابلات المستخدم، قابلية الاستخدام",
    forHr: "للموارد البشرية",
    forHrDesc: "الخروج، التفاعل، DEI",
    forTeams: "للفرق (B2B)",
    forTeamsDesc: "مساحات عمل متعددة المقاعد",
    forAcademic: "للبحث الأكاديمي",
    forAcademicDesc: "الدكتوراه، أعضاء هيئة التدريس، المختبرات",
    developers: "المطوّرون"
  }
};
